import React from "react";
import { Badge } from "../../../shared/components/Badge.jsx";
import { formatMovementTime, movementVariant, signedQuantity } from "./MovementCard.jsx";

const isLow = (item) => Number(item.stock || 0) <= Number(item.reorderLevel || 10);

/** Desktop table for Stock Levels; row click opens the stock adjustment sheet. */
export const stockLevelColumns = [
  { key: "itemName", label: "Item", sortValue: (item) => item.itemName || item.name || "", render: (item) => <strong>{item.itemName || item.name}</strong> },
  { key: "gstCode", label: "HSN", width: 120, render: (item) => item.gstCode || <span className="text-dim">—</span> },
  {
    key: "reorderLevel",
    label: "Reorder at",
    width: 120,
    align: "right",
    sortValue: (item) => Number(item.reorderLevel || 10),
    render: (item) => `${Number(item.reorderLevel || 10)} ${item.unit || "pcs"}`
  },
  {
    key: "stock",
    label: "In Stock",
    width: 130,
    align: "right",
    className: "amount",
    sortValue: (item) => Number(item.stock || 0),
    render: (item) => <span className={isLow(item) ? "text-warning" : "text-success"}>{Number(item.stock || 0)} {item.unit || "pcs"}</span>
  },
  {
    key: "status",
    label: "Status",
    width: 115,
    sortValue: (item) => (isLow(item) ? 0 : 1),
    render: (item) => <Badge variant={isLow(item) ? "warning" : "success"}>{isLow(item) ? "Low Stock" : "In Stock"}</Badge>
  }
];

/** Desktop table for Movement History (read-only). */
export const movementColumns = [
  {
    key: "createdAt",
    label: "When",
    width: 150,
    sortValue: (m) => (m.createdAt ? new Date(m.createdAt).getTime() : null),
    render: formatMovementTime
  },
  { key: "itemName", label: "Item", render: (m) => <strong>{m.itemName || "Unnamed Item"}</strong> },
  { key: "reason", label: "Reason", width: 220, optional: true, render: (m) => m.reason || <span className="text-dim">—</span> },
  { key: "type", label: "Type", width: 80, render: (m) => <Badge variant={movementVariant(m.type)}>{m.type}</Badge> },
  {
    key: "quantity",
    label: "Qty",
    width: 90,
    align: "right",
    className: "amount",
    sortValue: (m) => Number(m.quantity || 0) * (m.type === "OUT" ? -1 : 1),
    render: (m) => <span className={`text-${movementVariant(m.type)}`}>{signedQuantity(m)}</span>
  },
  {
    key: "stockChange",
    label: "Stock",
    width: 120,
    align: "right",
    noSort: true,
    render: (m) => `${m.previousStock} ➔ ${m.newStock}`
  }
];
